import PaymentMethod from "../../../components/paymentMethod";
import SelectUser from "../../../components/selectUser";
import {
    CreditCardFilled,
    UserOutlined,
  } from '@ant-design/icons';
  
import { Avatar, InputNumber } from 'antd';
import { LocalizationProvider, PickersLayout } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { styled } from '@mui/material/styles'
import TextArea from "antd/es/input/TextArea";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";


const PaymentDetails = forwardRef(({ formData, setFormData }, ref) => {

    const StyledPickersLayout = styled(PickersLayout)({
        '.MuiDateCalendar-root': {
          color: 'black',
        },
        '.MuiButtonBase-root': {
            background: 'white!important',
            color: 'black!important'
        },
        '.MuiPickersYear-yearButton':{
            background: 'white!important',
            color: 'black!important'
        },
        '.Mui-disabled':{
            color: 'rgba(0, 0, 0, 0.38)!important'
        },
        '.Mui-selected':{
            background: 'linear-gradient(90deg, rgba(67,0,36,1) 0%, rgba(67,5,68,1) 72%, rgba(87,6,88,1) 100%)!important',
            color:'white!important'
        },
    })

    const [user, setUser] = useState(formData.user || null);
    const [paymentMethod, setPaymentMethod] = useState(formData.paymentMethod || null);
    const [amount, setAmount] = useState(formData.amount || '');
    const [date, setDate] = useState(formData.date || null);
    const [comment, setComment] = useState(formData.comment || '');

    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        setFormData(prevFormData => ({ ...prevFormData,
            user,
            paymentMethod,
            amount,
            date,
            comment
         }));
    }, [user, paymentMethod, amount, date, comment, setFormData]);

    function validate(){
        const errors = {};

        if (!user) errors.user = "Selecciona un usuario";
        if (!paymentMethod) errors.paymentMethod = "Selecciona un método de pago";
        if (amount === null || amount === undefined || amount === "") {
            errors.amount = "Ingresa el valor pagado";
        }
        if (!date) errors.date = "Selecciona una fecha de pago";

       setFormErrors(errors);

       return Object.keys(errors).length === 0;
    }

    useImperativeHandle(ref, ()=>{
        return {
            validate,
        };
    });

    return (
        <div className="mt-4">
            <div className="m-auto w-100">
                <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between">
                    <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<UserOutlined />} />
                    <div className="w-75">
                        <SelectUser
                            className="w-100"
                            value={user}
                            onChange={setUser}
                        />
                        {formErrors.user && <div style={{ color: 'red' }}>{formErrors.user}</div>}
                    </div>
                </div>
                <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                    <CreditCardFilled className="icons" />
                    <div className="w-75">
                        <PaymentMethod
                            className="w-100"
                            value={paymentMethod}
                            onChange={setPaymentMethod}
                        />
                        {formErrors.paymentMethod && <div style={{ color: 'red' }}>{formErrors.paymentMethod}</div>}
                    </div>
                </div>
                <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                    <i className="fas fa-dollar-sign icons"></i>
                    <div className="w-75">
                        <InputNumber
                            className="w-100"
                            min={0}
                            placeholder="Valor Pagado"
                            formatter={value =>
                            value
                                ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                                : ''
                            }
                            parser={value => value ? value.replace(/\./g, '') : ''}
                            onChange={setAmount}
                        />
                        {formErrors.amount && <div style={{ color: 'red' }}>{formErrors.amount}</div>}
                    </div>
                </div>
                <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                    <i className="fas fa-calendar-day icons"></i>
                    <div className="w-75">
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <MobileDatePicker
                                className="w-100"
                                disableFuture={true}
                                slots={{ layout: StyledPickersLayout }}
                                value={date}
                                onChange={(newDate) => setDate(newDate)}
                            />
                        </LocalizationProvider>
                        {formErrors.date && <div style={{ color: 'red' }}>{formErrors.date}</div>}
                    </div>
                </div>
                <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                    <i className="fas fa-comments icons"></i>
                    <TextArea
                        rows={3}
                        placeholder="Comentario (Opcional)"
                        className="w-75"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </div>
            </div>
        </div>
    )
});

export default PaymentDetails;